import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgotPasswordAction, loginAction, resetPasswordAction, verifyOTP } from "../../store/user/userThunk";
import { ImSpinner8 } from "react-icons/im";
import { toast } from "react-toastify";
import { reset } from "store/lead/leadSlice";

export default function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userRole, setUserRole] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { user } = useSelector((state) => state.user);
  const [showEmailForForgotPassword, setShowEmailForForgotPassword] = useState(true);
  const [showOTP, setShowOTP] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [otp, setOTP] = useState("");
 const [forgot_password_email, setForgotPasswordEmail] = useState("");
  const [resetPassword, setResetPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (showEmailForForgotPassword) {
      if (!email) {
        toast.error("Please enter email");
        return;
      }
      // navigate("/admin/worker");
      setLoader(true); // Start loader
      dispatch(
        forgotPasswordAction({
          email: email,
          onSuccess: (user_email) => {
            dispatch(reset());
            setLoader(false); // Stop loader on success
            setShowEmailForForgotPassword(false)
            setShowOTP(true)
            setForgotPasswordEmail(user_email)
            toast.success(`OTP sent to ${user_email}`);
          },
          onError: (error, response) => {
            setLoader(false); // Stop loader on error
            console.error(error);
            toast.error(error)
          },
        })
      );
    }

    else if (showOTP) {
      if (!otp) {
        toast.error("Please enter OTP");
        return;
      }
      // navigate("/admin/worker");
      setLoader(true); // Start loader
      dispatch(
        verifyOTP({
          payload: {
            otp: otp,
            email: forgot_password_email
          },

          onSuccess: () => {
            dispatch(reset());
            setLoader(false); // Stop loader on success
            setShowEmailForForgotPassword(false)
            setShowOTP(false)
            setShowResetPassword(true)
          },
          onError: (error, response) => {
            setLoader(false); // Stop loader on error
            console.error(error);
            toast.error(error)
          },
        })
      );
    }


  else if (showResetPassword) {
    if (!resetPassword) {
      toast.error("Please enter OTP");
    }
    setLoader(true); // Start loader
      dispatch(
        resetPasswordAction({
          payload: {
            otp: otp,
            email: forgot_password_email,
            new_password: resetPassword
          },

          onSuccess: () => {
            dispatch(reset());
            setLoader(false); // Stop loader on success
            setShowEmailForForgotPassword(false)
            setShowResetPassword(false)
            toast.success("Password reset successfully");
            navigate("/auth/Login");

          },
          onError: (error, response) => {
            setLoader(false); // Stop loader on error
            console.error(error);
            toast.error(error)
          },
        })
      );
  }
};

  const handleNavigateLogin = (e) => {
    e.preventDefault();
    console.log("Login");
    navigate("/auth/Login");
  };


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="w-[60%] lg:w-[50%] xl:w-4/12 2xl:w-[500px] px-4">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
          <div className="rounded-t mb-0 px-6 py-6">
            <div className="text-center mb-3">
              <h6 className="text-blueGray-500 text-sm font-bold"> Forgot Password</h6>
            </div>
            <hr className="mt-6 border-b-1 border-blueGray-300" />
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form onSubmit={handleSubmit}>

              {showEmailForForgotPassword && (
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-email"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loader} // Disable input when loader is active
                  />
                </div>
              )
            }
                {showOTP && (
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-email"
                  >
                    OTP
                  </label>
                  <input
                    type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="OTP"
                    value={otp}
                    onChange={(e) => setOTP(e.target.value)}
                    disabled={loader} // Disable input when loader is active
                  />
                </div>
              )
              }

              {
                showResetPassword && (
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-email"
                    >
                      Reset Password
                    </label>
                    <input
                      type="text"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="OTP"
                      value={resetPassword}
                      onChange={(e) => setResetPassword(e.target.value)}
                      disabled={loader} // Disable input when loader is active
                    />
                  </div>
                )
              }
              <div className="text-center mt-6">
                <button
                  className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="submit"
                  disabled={loader} // Disable button when loader is active
                >
                  {loader ? <ImSpinner8 className="spinning-icon" /> : "Submit"}
                </button>
              </div>

              <div className="justify-end w-full flex">
                <button onClick={handleNavigateLogin}>Login</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

